import Workspace from "./workspace";
import { EventEmitter } from "eventemitter3";

export default class FileUploader extends EventEmitter {
  constructor(options) {
    super();
    options.urls = {}; 
    const prefix = options.domain;
    const endfix = "/stream/api/file/upload";
    const url = `${prefix}${endfix}`;
    options.urls.upload = `${url}/part`;
    options.urls.finish = `${url}/finish`;
    options.urls.blocks = `${url}/blocks`;
    options.urls.prepare = `${url}/prepare`;
    options.urls.abort = `${url}/abort`;
    this.onNetworkChange = this.onNetworkChange.bind(this);
    this.workspace = new Workspace(options);
    this.workspace.on("NewTasks", (tasks) => {
      this.emit("new-tasks", tasks);
    });
    this.workspace.on("RemoveTask", (tid) => {
      this.emit("remove-task", tid);
    });
    this.workspace.on("TaskStatusChange", (tid, status) => {
      this.emit("task-status-change", tid, status);
    });
    this.workspace.on("FileStatusChange", (tid, fid, status) => {
      this.emit("file-status-change", tid, fid, status);
    });
    this.workspace.on("UploadSpeed", (e) => {
      this.emit("upload-speed", e);
    });
    this.workspace.on("UploadProgress", (e) => {
      this.emit("upload-progress", e);
    });
    this.workspace.on("BeginHash", (tid, fid) => {
      this.emit("begin-hash", tid, fid);
    });
    this.workspace.on("EndHash", (tid, fid) => {
      this.emit("end-hash", tid, fid);
    });
    this.workspace.on("Hashing", (e) => {
      this.emit("hash-progress", e);
    });
    this.workspace.on("BeginPrepare", (tid, fid) => {
      this.emit("begin-prepare", tid, fid);
    })
    this.workspace.on("EndPrepare", (tid, fid) => {
      this.emit("end-prepare", tid, fid);
    });
    this.workspace.on("prepared", (file) => {
      this.emit("prepared", file);
    });
    this.workspace.on("BeginCommitBlocks", (tid, fid) => {
      this.emit("begin-commit-blocks", tid, fid);
    });
    this.workspace.on("EndCommitBlocks", (tid, fid) => {
      this.emit("end-commit-blocks", tid, fid);
    });
    this.workspace.on("BeginUploadFile", (tid, fid) => {
      this.emit("begin-upload-file", tid, fid);
    })
    this.workspace.on("EndUploadFile", (tid, fid) => {
      this.emit("end-upload-file", tid, fid);
    });
    this.workspace.on("BeginMergeFile", (tid, fid) => {
      this.emit("begin-merge-file", tid, fid);
    });
    this.workspace.on("EndMergeFile", (tid, fid) => {
      this.emit("end-merge-file", tid, fid);
    });
    this.workspace.on("TaskAbort", (tid) => {
      this.emit("abort", tid);
    });
    this.workspace.on("TaskComplete", task => {
      this.emit("complete", task);
    })
    this.workspace.on("error", (e) => {
      this.emit("error", e);
    });
    this.initialize();
  }

  initialize() {
    window.addEventListener("online", this.onNetworkChange);
    window.addEventListener("offline", this.onNetworkChange);
  }

  onNetworkChange() {
    const online = navigator.onLine;
    this.workspace.networkChange(online);
  }

  get() {
    return this.workspace.getTasks();
  }

  addFiles(items, pid, behavior) {
    return this.workspace.addFilesTask(items, pid, behavior);
  }

  addFolder(item, pid, behavior) {
    return this.workspace.addFolderTask(item, pid, behavior);
  }

  remove(tid) {
    return this.workspace.remove(tid);
  }

  resume(tid) {
    return this.workspace.resume(tid);
  }

  async pause(tid) {
    return await this.workspace.pause(tid);
  }

  destroy() {
    window.removeEventListener("online", this.onNetworkChange);
    window.removeEventListener("offline", this.onNetworkChange);
  }
}
